<kendo-dialog-titlebar (close)="feche()">
  <div class="titulo-modal-vinculo">
    <i class="fas fa-link"></i>
    <div>
      <h4>Vincular produto da fábrica</h4>
      <small>Selecione o produto da fábrica que será vinculado ao insumo da filial.</small>
    </div>
  </div>
</kendo-dialog-titlebar>

<div class="modal-body modal-body-vinculo">
  <div class="contexto-vinculo">
    <div class="insumo-contexto">
      <div class="icone-contexto"><i class="fas fa-box"></i></div>
      <div class="dado-contexto dado-insumo">
        <small>Insumo na filial</small>
        <strong>{{insumo?.nome || '-'}}</strong>
      </div>
      <div class="dado-contexto">
        <small>Unidade de compra</small>
        <strong>{{apresentacao?.apresentacaoCompra?.descricao || apresentacao?.descricao || '-'}}</strong>
      </div>
      <div class="dado-contexto">
        <small>Conversão</small>
        <strong>{{conversaoDaUnidade()}}</strong>
      </div>
    </div>
    <i class="fas fa-arrow-right seta-contexto"></i>
    <div class="aviso-contexto">
      <i class="fas fa-info-circle"></i>
      <span>Este vínculo define qual produto da fábrica será utilizado para repor o estoque deste insumo na filial.</span>
    </div>
  </div>

  <div class="text-center p-4" *ngIf="carregando && !resultado">
    <span class="spinner-border spinner-border-sm text-primary"></span>
    Carregando produtos da fábrica...
  </div>

  <div class="alert alert-danger mt-3" *ngIf="mensagemErro">{{mensagemErro}}</div>
  <div class="alert alert-success mt-3" *ngIf="mensagemSucesso">{{mensagemSucesso}}</div>

  <div class="alert alert-warning mt-3" *ngIf="resultado && semFabrica()">
    Configure uma fábrica fornecedora ativa antes de vincular um produto.
  </div>

  <div class="conteudo-vinculo" *ngIf="resultado && !semFabrica()">
    <section class="painel-busca">
      <div class="etapas-vinculo">
        <button type="button" [class.ativa]="etapa === 1" (click)="etapa = 1">
          <span>1</span>Buscar produto da fábrica
        </button>
        <button type="button" [class.ativa]="etapa === 2"
                [disabled]="!produtoSelecionado" (click)="etapa = 2">
          <span>2</span>Confirmar vínculo
        </button>
      </div>

      <div class="corpo-busca">
        <form (ngSubmit)="busquePorCodigo()">
          <label class="titulo-busca" for="codigoProdutoFabrica">
            <i class="fas fa-barcode"></i>Busca rápida por código
          </label>
          <div class="linha-busca-codigo">
            <input id="codigoProdutoFabrica" type="text" class="form-control"
                   name="codigoProdutoFabrica" maxlength="255"
                   [(ngModel)]="codigoFornecedor" autocomplete="off"
                   placeholder="Digite o código do produto"
                   [disabled]="buscandoCodigo || confirmando">
            <button type="submit" class="btn btn-blue"
                    [disabled]="buscandoCodigo || carregando || !codigoFornecedorValido()">
              <i class="fas fa-search mr-1"></i>Buscar
            </button>
          </div>
          <small class="text-muted">
            Se houver apenas um resultado elegível com este código, ele será selecionado para confirmação.
          </small>
        </form>

        <div class="separador"><span>ou</span></div>

        <form (ngSubmit)="pesquise()">
          <label class="titulo-busca" for="termoProdutoFabrica">
            <i class="fas fa-search"></i>Buscar por nome, código ou descrição
          </label>
          <div class="linha-busca-geral">
            <input id="termoProdutoFabrica" type="text" class="form-control"
                   name="termoProdutoFabrica" [(ngModel)]="termo" autocomplete="off"
                   placeholder="Digite nome, código ou descrição do produto">
            <button type="submit" class="btn btn-outline-primary">
              <i class="fas fa-search mr-1"></i>Pesquisar
            </button>
          </div>
        </form>

        <div class="filtros-produtos">
          <div>
            <label>Categoria</label>
            <select class="form-control" [(ngModel)]="categoriaFiltro"
                    [ngModelOptions]="{standalone: true}" (change)="pesquise()">
              <option value="">Todas</option>
              <option *ngFor="let categoria of categorias" [value]="categoria">{{categoria}}</option>
            </select>
          </div>
          <div>
            <label>Unidade</label>
            <select class="form-control" [(ngModel)]="unidadeFiltro"
                    [ngModelOptions]="{standalone: true}" (change)="pesquise()">
              <option value="">Todas</option>
              <option *ngFor="let unidade of unidades" [value]="unidade">{{unidade}}</option>
            </select>
          </div>
          <div>
            <label>Situação</label>
            <select class="form-control" disabled>
              <option>Elegíveis</option>
            </select>
          </div>
        </div>

        <div class="resultados-produtos">
          <strong>Resultados encontrados</strong>
          <div class="table-responsive mt-2">
            <table class="table table-hover mb-0">
              <thead>
                <tr>
                  <th class="col-selecao"></th>
                  <th>Produto da fábrica</th>
                  <th>Código</th>
                  <th>Unidade</th>
                  <th>Categoria</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let produto of produtosFiltrados"
                    [class.selecionado]="ehProdutoSelecionado(produto)"
                    (click)="selecioneProduto(produto)">
                  <td class="col-selecao">
                    <input type="radio" name="produtoFabricaSelecionado"
                           [checked]="ehProdutoSelecionado(produto)"
                           (change)="selecioneProduto(produto)">
                  </td>
                  <td><strong>{{produto.nome}}</strong></td>
                  <td>{{produto.codigo || '-'}}</td>
                  <td>{{unidadeDoProduto(produto)}}</td>
                  <td>{{categoriaDoProduto(produto)}}</td>
                </tr>
                <tr *ngIf="!produtosFiltrados.length">
                  <td colspan="5" class="text-center text-muted py-4">
                    Nenhum produto elegível encontrado.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <small class="text-muted d-block mt-2">
            {{produtosFiltrados.length}} produto(s) encontrado(s)
          </small>
        </div>
      </div>
    </section>

    <aside class="painel-resumo">
      <div class="titulo-resumo"><i class="far fa-file-alt"></i>Resumo da seleção</div>

      <div class="resumo-vazio" *ngIf="!produtoSelecionado">
        <i class="fas fa-mouse-pointer"></i>
        <strong>Selecione um produto</strong>
        <span>Escolha um produto da lista para revisar o vínculo.</span>
      </div>

      <ng-container *ngIf="produtoSelecionado">
        <div class="mapa-vinculo">
          <div class="card-entidade">
            <small>Insumo na filial</small>
            <strong>{{insumo?.nome || '-'}}</strong>
          </div>
          <i class="fas fa-link"></i>
          <div class="card-entidade">
            <small>Produto da fábrica</small>
            <strong>{{produtoSelecionado.nome}}</strong>
            <span>Código: {{produtoSelecionado.codigo || '-'}}</span>
          </div>
        </div>

        <dl class="detalhes-selecao">
          <div><dt>Unidade do produto</dt><dd>{{unidadeDoProduto(produtoSelecionado)}}</dd></div>
          <div><dt>Categoria</dt><dd>{{categoriaDoProduto(produtoSelecionado)}}</dd></div>
          <div><dt>Situação na fábrica</dt><dd><span class="badge badge-success">Elegível</span></dd></div>
          <div>
            <dt>Estoque disponível na fábrica</dt>
            <dd class="estoque-disponivel">
              {{estoqueDisponivel(produtoSelecionado) | number:'1.0-3'}}
              {{unidadeDoProduto(produtoSelecionado)}}
            </dd>
          </div>
          <div><dt>Preço atual</dt><dd>{{produtoSelecionado.preco | currency:'BRL'}}</dd></div>
          <div *ngIf="produtoSelecionado.insumoOrigem?.estoque?.ultimaAtualizacao">
            <dt>Última atualização do estoque</dt>
            <dd>{{produtoSelecionado.insumoOrigem.estoque.ultimaAtualizacao | date:'dd/MM/yyyy HH:mm'}}</dd>
          </div>
        </dl>

        <div class="aviso-confirmacao">
          <i class="fas fa-info-circle"></i>
          <span>Ao confirmar, este produto da fábrica será usado na reposição do estoque do insumo na filial.</span>
        </div>
      </ng-container>
    </aside>
  </div>
</div>

<div class="rodape-vinculo">
  <button type="button" class="btn btn-outline-danger mr-auto" *ngIf="produtoAtual()"
          (click)="remova()" [disabled]="removendo || confirmando">
    <i class="fas fa-unlink mr-1"></i>Remover vínculo
  </button>
  <button type="button" class="btn btn-light" (click)="feche()"
          [disabled]="confirmando || removendo">Cancelar</button>
  <button type="button" class="btn btn-confirmar-vinculo" (click)="confirmeVinculo()"
          [disabled]="!produtoSelecionado || confirmando || removendo || ehProdutoAtual(produtoSelecionado)">
    <i class="fas fa-link mr-1"></i>Confirmar vínculo com {{apresentacao?.apresentacaoCompra?.descricao || apresentacao?.descricao}}
    <i class="k-icon k-i-loading ml-1" *ngIf="confirmando"></i>
  </button>
</div>
